// extracted by mini-css-extract-plugin
export default {"abaHeader":"ABAComponents_abaHeader__YT8Vv","abaTextInputLabel":"ABAComponents_abaTextInputLabel__tVu1A","abaTextInputErrorMessage":"ABAComponents_abaTextInputErrorMessage__5STCi"};